import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

const WhatsAppFloatingButton = () => {
  const phoneNumber = '9647500053313'
  const message = 'Hi! How can I help you?'
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="!fixed bottom-[90px] sm:bottom-48 md:bottom-32 end-7 sm:end-2 z-[9999] p-4 sm:p-3 rounded-full shadow-lg bg-green-600 cursor-pointer hover:bg-green-800 transition duration-200 ease-in-out"
    >
      <FaWhatsapp size={28} color="white" />
    </a>
  )
}

export default WhatsAppFloatingButton
